import React from 'react';
import AuthenticationPageView from './view';


export default function AuthenticationPage() {
  return <AuthenticationPageView />;
};
